import React, { ChangeEvent } from 'react';
import { Box, Text, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export const ActionRequiredCandidateView = ({
  tempSearchAndSortType,
  setTempSearchAndSortTypes,
}: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation();
  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleInterventionEnabled = (isInterventionEnabled: boolean) => {
    // searchAndSortTypes.isInterventionEnabled = isInterventionEnabled;
    const updatedFilters = {
      ...tempSearchAndSortType,
      isInterventionEnabled,
    };
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes(updatedFilters);
  };
  return (
    <Box>
      <Checkbox
        data-testid="actionRequiredCheckBox"
        isChecked={tempSearchAndSortType.isInterventionEnabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onHandleInterventionEnabled(e.target.checked)}
      >
        <Text
          px={3}
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
          }}
        >
          {t('searchAndSort.actionRequiredCandidates')}
        </Text>
      </Checkbox>
    </Box>
  );
};
